<script setup lang="ts"></script>

<template>
   <!-- The app target keeps /login, /payment and /forms on this layout, and they have no
        nav of their own to absorb the status bar and home indicator. Both insets are 0 on
        the web, so the 13 website builds are unaffected. -->
   <div class="pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]">
      <slot>
         <NuxtPage />
      </slot>
   </div>
</template>

<style scoped></style>
